module.exports = __webpack_public_path__ + "img/12.68cd9bf5.png";